<template>
  <div>
    <div class="head">
      <img :src="baseUrl + headInfo.iconUrl" alt="">
      <p>{{ headInfo.title }}</p>
      <a class="banner_btn" @click="contactUs">{{ headInfo.remark }} &gt;</a>
    </div>
    <div class="current_menu">
      <div class="content">
        <ul>
          <li v-for="(item,index) in infoList" :key="index" :class="{'active': index === activeIndex }" @click="handleSelect(index,item)">{{ item.title }}</li>
        </ul>
        <a class="home" @click="goHome" />
      </div>
    </div>
    <div v-if="infoList.length" class="info">
      <div v-for="(item,index) in infoList" :key="index">
        <div v-if="item.flag === '6'" class="brief current_content">
          <p class="current_title">{{ item.title }}</p>
          <div class="content">
            <div class="left">
              <p class="title">{{ item.shortTitle }}</p>
              <p v-for="(cItem,cIndex) in item.remarkArr" :key="cIndex">{{ cItem }}</p>
            </div>
            <div class="right">
              <img :src="baseUrl + item.iconUrl" alt="">
            </div>
          </div>
        </div>
        <div v-else-if="item.flag === '1'" class="brief brief_other current_content">
          <p class="current_title">{{ item.title }}</p>
          <div class="content">
            <div class="left">
              <p class="title">{{ item.shortTitle }}</p>
              <p>{{ item.remark }}</p>
            </div>
            <div class="right">
              <img :src="baseUrl + item.iconUrl" alt="">
            </div>
          </div>
        </div>
        <div v-else-if="item.flag === '2'" class="feature current_content">
          <p class="current_title">{{ item.title }}</p>
          <ul>
            <li v-for="(childItem,childIndex) in item.children" :key="childIndex">
              <img :src="baseUrl + childItem.iconUrl" alt="">
              <p class="title">{{ childItem.title }}</p>
              <p class="text">{{ childItem.remark }}</p>
            </li>
          </ul>
        </div>
        <div v-else-if="item.flag === '3'" class="advantage current_content">
          <p class="current_title">{{ item.title }}</p>
          <div class="content">
            <div v-for="(childItem,childIndex) in item.children" :key="childIndex">
              <p class="large">{{ childItem.title }}</p>
              <p v-for="(ccItem,ccIndex) in childItem.remarkArr" :key="ccIndex" class="small">{{ ccItem }}</p>
            </div>
          </div>
        </div>
        <div v-else-if="item.flag === '4'" class="introduce current_content">
          <p class="current_title">{{ item.title }}</p>
          <ul>
            <li
              v-for="(childItem,childIndex) in item.children"
              :key="childIndex"
              @mouseover="childItem.showText = true"
              @mouseleave="childItem.showText = false"
            >
              <div v-if="!childItem.showText" class="image_box">
                <img :src="baseUrl + childItem.iconUrl" alt="">
                <p class="large">{{ childItem.title }}</p>
              </div>
              <div v-if="childItem.showText" class="text_box">
                <p class="large">{{ childItem.title }}</p>
                <p class="small">{{ childItem.remark }}</p>
              </div>
            </li>
          </ul>
        </div>
        <ul v-else-if="item.flag === '5'" class="brief_list">
          <li v-for="(childItem,childIndex) in item.children" :key="childIndex">
            <div class="img_box">
              <img :src="baseUrl+ childItem.iconUrl" alt="">
            </div>
            <div class="right">
              <div>
                <p class="title">{{ childItem.title }}</p>
                <div class="block" />
                <p class="text">
                  {{ childItem.remark }}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="no_info">暂无信息</div>
  </div>
</template>
<script>
import { contactUs, goHome } from '@/plugin/operate.js'
import { getMainContent } from '@/plugin/api'

export default {
  data() {
    return {
      activeIndex: 0,
      infoList: [],
      headInfo: {},
      baseUrl: '/website'
    }
  },
  mounted() {
    const params = this.$route.query
    params.tenantId = 'sft'
    this.getInfo(params)
  },
  methods: {
    contactUs,
    goHome,
    handleSelect(key, keyItem) {
      const wTop = document.getElementsByClassName('info')[0].childNodes[key + 1].offsetTop
      window.scrollTo({
        top: wTop - 80,
        behavior: 'smooth'
      })
    },
    getInfo(params) {
      getMainContent(params).then(res => {
        if (res.data.code === 200) {
          const rArr = res.data.data.contentMainList[0].contentItemTreeList
          rArr.forEach(item => {
            switch (item.flag) {
              case '3':
                item.children.forEach(cItem => {
                  cItem.remarkArr = cItem.remark.split('\n')
                })
                break
              case '4':
                item.children.forEach(cItem => {
                  cItem.showText = false
                })
                break
              case '6':
                item.remarkArr = item.remark.split('\n')
                break
            }
          })
          this.headInfo = rArr.find(item => {
            return item.flag === '0'
          })
          this.infoList = rArr.filter(item => {
            return item.flag !== '0'
          })
        }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
@import "../assets/css/detail.scss";
.head{
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    position: absolute;
    z-index: -1;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
  }
  p{
    color: #fff;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
}
</style>
